import { Link, useLocation } from "react-router-dom";
import { Card, Typography } from "@mui/material";
import { Image } from "@mui/icons-material";
import { AxiosGet } from "../../../service/CommonFunction/TS_function";
import { useEffect, useState } from "react";

interface propInnerHeadRout {
    iconMUI?: any;
    labal_Head: string;
    label_nameRoute?: string
    path?: string
}

const InnerHeadRoutes: React.FC<propInnerHeadRout> = ({
    iconMUI = <Image />,
    labal_Head = "labal_Head",
    label_nameRoute,
    path = ""
}) => {
    const location = useLocation();
    const pathname = location.pathname
    const sitename = process.env.REACT_APP_SITE_NAME ? "/" + process.env.REACT_APP_SITE_NAME : ""
    var [rootPath, setRootPath] = useState(path)

    useEffect(() => {
        // GetHeadMenu();
    }, [pathname])

    const GetHeadMenu = () => {
        AxiosGet(`TM_Menu/GetHeadMenu`, { path: pathname }, (result: any) => {
            if (rootPath != null && result.sUrl != null) {
                setRootPath(result.sUrl)
            }
        })
    }

    return (
        <Card sx={{ p: 1, mb: 1, borderLeft: "8px solid #00ADEE", display: "flex", flexDirection: "row", color: "#1e456c"}}>
            <div style={{ marginRight: "4px" }}>
                {iconMUI}
            </div>
            <Typography variant="subtitle1">
                {`${labal_Head}`}
            </Typography>

            <Link to={`${rootPath}`}>
                <Typography variant="subtitle1" sx={{ color: "#1e456c", ml: 1 }}>
                    {`${label_nameRoute ? "> " + label_nameRoute : ""}`}
                </Typography>
            </Link>
        </Card>
    )
}

export default InnerHeadRoutes